import { createContext, useContext, useEffect, useState } from "react";
import { initializeApp } from "firebase/app";

import {
  getAuth,
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
} from "firebase/auth";
import { getDatabase, get,ref, set, onValue } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyBZSb6AhI3WQYF-lRtPO85C_z10mFdU04s",
  authDomain: "kkg-portfolio-d83bc.firebaseapp.com",
  projectId: "kkg-portfolio-d83bc",
  storageBucket: "kkg-portfolio-d83bc.appspot.com",
  messagingSenderId: "1045399508286",
  appId: "1:1045399508286:web:3b7d3ec9ecda9209c4886f",
  measurementId: "G-WVKLDYQ8JL",
  databaseURL: "https://kkg-portfolio-d83bc-default-rtdb.firebaseio.com/"
};
// const firebaseConfig = {
//   apiKey: "AIzaSyDkZYxigusbqyHJvmRym6E8aDivfrSG58s",
//   authDomain: "saurabh-portfolio-9a2e0.firebaseapp.com",
//   databaseURL: "https://saurabh-portfolio-9a2e0-default-rtdb.firebaseio.com",
//   projectId: "saurabh-portfolio-9a2e0",
//   storageBucket: "saurabh-portfolio-9a2e0.appspot.com",
//   messagingSenderId: "693208755515",
//   appId: "1:693208755515:web:956b8e3e2af65c70cf9b1e",
//   measurementId: "G-XGCNH5T15C"
// };

const firebaseApp = initializeApp(firebaseConfig);
const firebaseAuth = getAuth(firebaseApp);
const database = getDatabase(firebaseApp);

const FirebaseContext = createContext(null);
const googleProvider = new GoogleAuthProvider();

export const useFireBase = () => useContext(FirebaseContext);

export const FirebaseProvider = (props) => {
  const signupWithGoogle = () => {
   return  signInWithPopup(firebaseAuth, googleProvider);
  };

  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(firebaseAuth, (authUser) => {
      setUser(authUser);
    });

    return () => unsubscribe();
  }, []);

  const logout = () => {
    
    signOut(firebaseAuth);
  };

  const addUserInfo = (uid, userInfo) => {
    // Your logic to add user info to the database
    // For example, using the Realtime Database
    const userRef = ref(database, `users/${uid}`);
    set(userRef, userInfo);
  };
  const signupUserWithEmailandPassword = async (email, password) => {
    try {
      await createUserWithEmailAndPassword(firebaseAuth, email, password);
      console.log("User signed up successfully");
    } catch (error) {
      console.error("Error during sign up:", error.message);
      throw error;
    }
  };

  const signInUserWithEmailandPassword = async (email, password) => {
    try {
      await signInWithEmailAndPassword(firebaseAuth, email, password);
      console.log("User signed in successfully");
    } catch (error) {
      console.error("Error during sign in:", error.message);
      throw error;
    }
  };

  useEffect(() => {
    onAuthStateChanged(firebaseAuth, (user) => {
      if (user) setUser(user);
      else setUser(null);
    });
  }, []);

  const isLoggedIn = user ? true : false;

  const putData = (key, data) => set(ref(database, key), data);  

  const getData = async (path) => {
    const dataRef = ref(database, path);
    const snapshot = await get(dataRef);
    return snapshot.val();
  };
  // Inside FirebaseProvider
  const updateUserStatus = async (uid, newStatus) => {
    const userRef = ref(database, `users/${uid}`);
    await set(userRef, { status: newStatus }, { merge: true });
  };
  

  return (
    <FirebaseContext.Provider
      value={{
        signupUserWithEmailandPassword,
        signInUserWithEmailandPassword,
        putData,
        getData,
        signupWithGoogle,
        isLoggedIn,
        logout,
        database,
        addUserInfo,
        updateUserStatus,
      }}
    >
      {props.children}
    </FirebaseContext.Provider>
  );
};

export default FirebaseProvider;
